import type { FunctionComponent } from "react"

import { Callout } from "@jobteaser/spark/components/Callout"
import { Text } from "@jobteaser/spark/components/Text"

import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./StatusDeclined.module.css"

export const StatusDeclined: FunctionComponent = () => {
  const { t } = useTranslation(["event_details"])

  return (
    <Callout variant="error" className={styles.main} data-testid="event-details-registration-details-status-declined">
      <Text variant="body1" weight="bold" data-testid="event-details-registration-details-status-declined-title">
        {t(`event_details.status.declined`)}
      </Text>
      <Text variant="body1" data-testid="event-details-registration-details-status-declined-text">
        {t(`event_details.status.declined_message`)}
      </Text>
    </Callout>
  )
}
